var React = require('react');

function Api (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 22v-1h6v-2h-6v-6h6v-2h-6v-1c0-1.097-.903-2-2-2h-6c-4.009.007-7.426 3.023-7.931 7H2v2h6.069c.505 3.977 3.922 6.993 7.931 7h6c1.097 0 2-.903 2-2Zm-8 0c-3.292 0-6-2.708-6-6s2.708-6 6-6h6v12h-6Z","style":{"fillRule":"nonzero"}}));
}

Api.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = Api;

Api.default = Api;
